module.exports = __webpack_public_path__ + "img/3-3.3ceea5d0.png";